// Union staff's private review of an apprenticeship application: exam result, requirements met,
// and staff notes. These live in apprenticeship_application_reviews (one row per application,
// readable and writable only by active staff of that application's union) rather than on
// apprenticeship_applications, which the applying worker can read. A missing row simply means
// nothing has been recorded yet.

// PostgREST embed for an apprenticeship_applications select. application_id is the review
// table's primary key, so the embed is one-to-one.
export const REVIEW_EMBED = 'apprenticeship_application_reviews(exam_result, requirements_met, staff_notes)';

export const EMPTY_REVIEW = { exam_result: null, requirements_met: null, staff_notes: null };

// The embed arrives as an object (one-to-one) or, on some PostgREST versions, a 0/1-item array.
export function reviewFromEmbed(embed) {
  const row = Array.isArray(embed) ? embed[0] : embed;
  if (!row) return { ...EMPTY_REVIEW };
  return { exam_result: row.exam_result ?? null, requirements_met: row.requirements_met ?? null, staff_notes: row.staff_notes ?? null };
}

// The "M" in "N of M met": the posting's own requirements list. The Candidates editor and the
// Compare view both call this on the same loaded posting, so their totals can never disagree.
export function requirementsTotal(apprenticeship) {
  return Array.isArray(apprenticeship?.requirements) ? apprenticeship.requirements.length : 0;
}

// Writes exactly one field. Upserting on application_id creates the row on first use; sending
// only the changed key means PostgREST's merge never touches the other two columns. The write
// only counts as persisted when .select() hands the row back -- an RLS denial on an upsert can
// come back as an empty result rather than an error, and that must not read as "Saved".
export async function saveReviewField(supabase, applicationId, field, value) {
  const { data, error } = await supabase
    .from('apprenticeship_application_reviews')
    .upsert({ application_id: applicationId, [field]: value }, { onConflict: 'application_id' })
    .select('application_id, exam_result, requirements_met, staff_notes');
  const row = Array.isArray(data) ? data[0] : data;
  if (error || !row || row.application_id !== applicationId || (row[field] ?? null) !== (value ?? null)) {
    return { ok: false, error: error?.message || 'not persisted' };
  }
  return { ok: true, review: reviewFromEmbed(row) };
}
